<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#E34041" />
    <path
      d="M11.0426 5.816H12.9786V13.656H11.0426V5.816ZM12.0026 17.24C11.6826 17.24 11.4106 17.1333 11.1866 16.92C10.9732 16.696 10.8666 16.4293 10.8666 16.12C10.8666 15.8 10.9732 15.5333 11.1866 15.32C11.4106 15.1067 11.6826 15 12.0026 15C12.3226 15 12.5892 15.1067 12.8026 15.32C13.0266 15.5333 13.1386 15.8 13.1386 16.12C13.1386 16.4293 13.0266 16.696 12.8026 16.92C12.5786 17.1333 12.3119 17.24 12.0026 17.24Z"
      fill="white"
    />
  </svg>
</template>
